/**
 * Content Slide Renderer
 * Routes and renders all content slide types
 */

import type { ContentSlideProps } from './types';
import TextImageSlide from './content/TextImageSlide';
import VideoSlide from './content/VideoSlide';
import PdfSlide from './content/PdfSlide';
import WebContentSlide from './content/WebContentSlide';
import FieldTripSlide from './content/FieldTripSlide';
import AudioSlide from './content/AudioSlide';
import TextOnlySlide from './content/TextOnlySlide';

/**
 * Routes to the correct content slide component based on slide type
 */
export default function ContentSlideRenderer({ slide, className = '', hideHeading, viewMode = 'student' }: ContentSlideProps) {
  const shouldHideHeading = hideHeading || slide.content?.showTitle === false;

  switch (slide.type) {
    case 'text_image':
      return <TextImageSlide slide={slide} className={className} hideHeading={shouldHideHeading} viewMode={viewMode} />;
    case 'video':
      return <VideoSlide slide={slide} className={className} viewMode={viewMode} />;
    case 'pdf':
      return <PdfSlide slide={slide} className={className} viewMode={viewMode} />;
    case 'web_content':
      return <WebContentSlide slide={slide} className={className} viewMode={viewMode} />;
    case 'field_trip':
      return <FieldTripSlide slide={slide} className={className} viewMode={viewMode} />;
    case 'audio':
      return <AudioSlide slide={slide} className={className} viewMode={viewMode} />;
    case 'text_only':
      return <TextOnlySlide slide={slide} className={className} viewMode={viewMode} />;
    default:
      return (
        <div className={`text-center text-muted-foreground ${className}`}>
          Unknown content slide type: {slide.type}
        </div>
      );
  }
}
